import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import {
  CheckCircle,
  HourglassEmpty,
  Close,
  ConfirmationNumber,
} from '@mui/icons-material';

export type TicketStatus = 'open' | 'in_progress' | 'resolved' | 'closed';

interface StatusChipProps extends Omit<ChipProps, 'color' | 'icon' | 'label'> {
  status: TicketStatus;
  showIcon?: boolean;
}

const getStatusConfig = (status: TicketStatus) => {
  switch (status) {
    case 'open':
      return {
        color: 'primary' as const,
        label: 'Open',
        icon: <ConfirmationNumber fontSize="small" />,
        backgroundColor: '#e3f2fd',
        textColor: '#1976d2',
      };
    case 'in_progress':
      return {
        color: 'warning' as const,
        label: 'In Progress',
        icon: <HourglassEmpty fontSize="small" />,
        backgroundColor: '#fff3e0',
        textColor: '#f57c00',
      };
    case 'resolved':
      return {
        color: 'success' as const,
        label: 'Resolved',
        icon: <CheckCircle fontSize="small" />,
        backgroundColor: '#e8f5e8',
        textColor: '#2e7d32',
      };
    case 'closed':
      return {
        color: 'default' as const,
        label: 'Closed',
        icon: <Close fontSize="small" />,
        backgroundColor: '#f5f5f5',
        textColor: '#757575',
      };
    default:
      return {
        color: 'default' as const,
        label: 'Unknown',
        icon: <ConfirmationNumber fontSize="small" />,
        backgroundColor: '#f5f5f5',
        textColor: '#757575',
      };
  }
};

export default function StatusChip({ 
  status, 
  showIcon = true, 
  sx,
  ...props 
}: StatusChipProps) {
  const config = getStatusConfig(status);

  return (
    <Chip
      {...props}
      label={config.label}
      color={config.color}
      icon={showIcon ? config.icon : undefined}
      size="small"
      sx={{
        fontWeight: 500,
        ...sx,
      }}
    />
  );
}